/* Copyright (c) 2025 Xperi. All Rights Reserved.  */

import '../FilteredGuideTableRow/FilteredGuideTableRow.scss';

const FilteredGuideTurboScrollRow = () => {
    return (
        <div className="filtered-guide-table-row-container">
            <div className="filtered-guide-generic-row">
                <div className="filtered-guide-left-side-table filtered-guide-channel-cell"></div>
                <div
                    className="filtered-guide-right-side-table text filtered-guide-show-cell"
                    data-testid="filtered-guide-program-cell"
                ></div>
            </div>
        </div>
    );
};

export default FilteredGuideTurboScrollRow;
